import React from 'react';
import { Helmet } from 'react-helmet-async';
import Partners from './Partners';
import useRouter from '../../hooks/useRouter';
import PageHeading from '../../@communityshare/ui/PageHeading';
import Results from '../_common_results/Results';
import User from '../_common_user/ManageUser';
import DateJoined from '../_common_user/User/DateJoined';
import LastActive from '../_common_user/User/LastActive';
import Filters from '../../forms/filters_partners';
import { UsersIcon } from '@heroicons/react/24/outline';
import MobileNavigation from '../partners/MobileNavigation';
import TextField from '../projects/_fields/TextField';
import Invitations from './Invitations';
import Questions from './Questions';
import Claims from '../educators-engagement/Claims';
import Projects from '../educators-engagement/Projects';
import Events from '../educators-engagement/Events';
import Offers from './Offers';

export default function Layout(props) {
  const router = useRouter();

  return (
    <div className="p-8 space-y-8">
      <Helmet>
        <title>Explore Partners</title>
      </Helmet>
      <MobileNavigation />
      <PageHeading
        breadcrumbs={['Explore', 'Partners']}
        title="All Partners (by engagement)"
        description={(
          <>
            This page shows all partners in your network, through the lens of engagement. Use
            the filters to narrow the list. Find a filter you want to see again in the future?
            Bookmark the page or save a link to the URL.
          </>
        )}
      />
      <Filters router={router} />
      <Partners router={router}>
        {function(result) {
          return (
            <Results result={result} columns={3} resource="partners" emptyIcon={UsersIcon}>
              {function(user, index) {
                return (
                  <User
                    key={index}
                    user={user}
                  >
                    <div className="bg-cs-gray-50 p-4 border-t border-cs-gray-100 space-y-4">
                      <div className="grid grid-cols-2">
                        <LastActive user={user} />
                        <DateJoined user={user} align="right" />
                      </div>
                      {/*<div className="grid grid-cols-2">*/}
                      {/*  <TextField label="Projects">*/}
                      {/*    <Projects user={user} />*/}
                      {/*  </TextField>*/}
                      {/*  <TextField label="Events" align="right">*/}
                      {/*    <Events user={user} />*/}
                      {/*  </TextField>*/}
                      {/*</div>*/}
                      <div className="grid grid-cols-2">
                        <TextField label="Project invitations">
                          <Questions user={user} />
                        </TextField>
                        <TextField label="Event invitations" align="right">
                          <Invitations user={user} />
                        </TextField>
                      </div>
                      <TextField label="Offers">
                        <Offers user={user} />
                      </TextField>
                      {/*<TextField label="Offer invitations">*/}
                      {/*  <Claims user={user} />*/}
                      {/*</TextField>*/}
                    </div>
                  </User>
                );
              }}
            </Results>
          );
        }}
      </Partners>
    </div>
  );
}
